export default __webpack_public_path__ + "static/media/faq-ticket.0691c0e3.png";